module.exports = __webpack_public_path__ + "img/点对齐-角标.4daa927e.svg";